var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBetslip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.5 24.37"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon - Betslip"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.75 22.662a.5.5 0 01-.5.5.5.5 0 01-.325-.12L14.25 20.75l-3.7 2.774a.5.5 0 01-.6 0l-3.7-2.774-4.675 2.292a.5.5 0 01-.7-.055.5.5 0 01-.12-.325V1.75a1 1 0 011-1h17a1 1 0 011 1z",
    "data-name": "Shape 594"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M5.25 5.75h8.5",
    "data-name": "Shape 596"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M5.25 9.75h10",
    "data-name": "Shape 597"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M5.25 13.75h6.5",
    "data-name": "Shape 598"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMC41IDI0LjM3Ij48ZyBkYXRhLW5hbWU9Ikljb24gLSBCZXRzbGlwIj48ZyBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiIGRhdGEtbmFtZT0iR3JvdXAgNzAiPjxwYXRoIGQ9Ik0xOS43NSAyMi42NjJhLjUuNSAwIDAgMS0uNS41LjUuNSAwIDAgMS0uMzI1LS4xMkwxNC4yNSAyMC43NWwtMy43IDIuNzc0YS41LjUgMCAwIDEtLjYgMGwtMy43LTIuNzc0LTQuNjc1IDIuMjkyYS41LjUgMCAwIDEtLjctLjA1NS41LjUgMCAwIDEtLjEyLS4zMjVWMS43NWExIDEgMCAwIDEgMS0xaDE3YTEgMSAwIDAgMSAxIDFaIiBkYXRhLW5hbWU9IlNoYXBlIDU5NCIvPjxwYXRoIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGQ9Ik01LjI1IDUuNzVoOC41IiBkYXRhLW5hbWU9IlNoYXBlIDU5NiIvPjxwYXRoIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGQ9Ik01LjI1IDkuNzVoMTAiIGRhdGEtbmFtZT0iU2hhcGUgNTk3Ii8+PHBhdGggc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTUuMjUgMTMuNzVoNi41IiBkYXRhLW5hbWU9IlNoYXBlIDU5OCIvPjwvZz48L2c+PC9zdmc+Cg==";
export { SvgIconBetslip as ReactComponent };